import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import StepButton from "components/views/StepButton";
import T from "i18n";
import { useNavigate, useLocation } from "react-router-dom";
import { useManufacturers } from "api/hooks";
import queryString from "query-string";

const Wrapper = styled.ul`
  display: grid;
  grid-gap: ${({ theme }) => theme.spacer}px;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));

  ${({ theme }) => theme.mediaQueries.medium} {
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  }
`;

const SearchTypeSelector = ({ className }) => {
  const classes = ["SearchTypeSelector"];

  const { data } = useManufacturers();
  const navigate = useNavigate();
  const location = useLocation();

  function handleClick(item) {
    return () => {
      const type = item.id;
      // getting the selected manufacturer
      const search = queryString.parse(location.search);
      const manufacturerid = parseInt(search.manufacturerid, 10);
      const iframe = search.iframe != null ? search.iframe : false;

      const oem = data.find((m) => m.id === manufacturerid);

      switch (type) {
        case "engine_types_id":
          navigate(
            `/engine_model_group?manufacturerid=${manufacturerid}&groupid=${oem[type]}&iframe=${iframe}`
          );
          break;
        default:
          navigate(
            `/specification_group?manufacturerid=${manufacturerid}&groupid=${oem[type]}&iframe=${iframe}`
          );
          break;
      }
    };
  }

  const searchTypes = [
    {
      label: T({ path: "searchTypeSelector.engineType" }),
      id: "engine_types_id",
    },
    {
      label: T({ path: "searchTypeSelector.specification" }),
      id: "specifications_id",
    },
  ];

  if (className) classes.push(className);

  return (
    <Wrapper className={classes.join(" ")}>
      {searchTypes.map((item) => (
        <li key={item.label}>
          <StepButton
            label={item.label}
            onClick={handleClick(item)}
            className="ellipsis"
          />
        </li>
      ))}
    </Wrapper>
  );
};

SearchTypeSelector.displayName = "SearchTypeSelector";

SearchTypeSelector.propTypes = {
  className: PropTypes.string,
};

SearchTypeSelector.defaultProps = {
  className: null,
};

export default SearchTypeSelector;
